import { MutationHookOptions, useMutation } from '@apollo/client';
import { PARENT_SIGN_RECAP_FORM } from './mutations';
export const useParentSignRecapForm = (options?: MutationHookOptions) => useMutation(PARENT_SIGN_RECAP_FORM, options);
